import React, {useEffect, useImperativeHandle, useState} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import functions from "../../../../utils/functionsFirebase";
import {InputSaveEdit} from "../../../shared";

const TagForm = React.forwardRef((props, ref) => {

    const intl = useIntl();

    const [tag, setTag] = useState(props.tag?.tag ?? "");
    const [color, setColor] = useState(props.tag?.color);

    useEffect(() => {
        props.setValidTag(!!tag);
    }, [tag]);

    useEffect(() => {
        setTag(props.tag?.tag ?? "");
        setColor(props.tag?.color ?? getRandomHexColor());
    }, [props.tag]);

    function getRandomHexColor() {
        // Generate random values for the red, green, and blue components
        const red = Math.floor(Math.random() * 256); // 0 to 255
        const green = Math.floor(Math.random() * 256); // 0 to 255
        const blue = Math.floor(Math.random() * 256); // 0 to 255

        // Convert the decimal values to hexadecimal
        const redHex = red.toString(16).padStart(2, '0');
        const greenHex = green.toString(16).padStart(2, '0');
        const blueHex = blue.toString(16).padStart(2, '0');

        // Combine the hexadecimal values to form a color code
        return `#${redHex}${greenHex}${blueHex}`;
    }

    async function saveTag() {
        const saveTag = functions.httpsCallable('saveTag');
        const tagObj = {
            id: props.tag.id,
            tag,
            color,
            totalFiles: props.tag.totalFiles ? props.tag.totalFiles : 0,
            groupId: props.groupId
        };
        const res = await saveTag({groupId: props.groupId, tag: tagObj});
    }

    useImperativeHandle(ref, () => ({
        // Method to save the role that is being edited
        saveTag: () => {
            return saveTag();
        },
    }));

    if (!props.tag) {
        return;
    }

    return (
        <div>
            <label style={{fontWeight: "bold"}} htmlFor="tagName">
                <FormattedMessage id="tags.tag-form.field.name"/>
            </label>
            <div className="d-flex flex-row align-items-top col-12">
                <div style={{width: "30px", height: "30px", borderRadius: "30px", overflow: "hidden"}}
                     className="position-relative mb-2 me-3 mt-1 col-2">
                    {color && <input type="color" value={color} className="p-0 position-absolute"
                            style={{
                                border: "none",
                                width: "52px",
                                height: "52px",
                                left: "-5px",
                                top: "-5px",
                                cursor: "pointer"
                            }}
                            onChange={e => setColor(e.target.value)}/>}
                </div>
                <div className="mb-2 col-10">
                    <InputSaveEdit id="tagName" onSave={value => setTag(value)} inputValue={tag}
                                   alwaysEditing={true} maxLength={20} required={true} showLabel={false}
                                   label={intl.formatMessage({id: "tags.tag-form.field.name"})}/>
                </div>

            </div>
        </div>
    )
});

export default TagForm;
